import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import useSidebarState from "./useSidebarState";
import usePageMeta from "./usePageMeta";

/**
 * The real shell. Mounted once in App.js for every authenticated route.
 * Renders Sidebar + Header + Footer + a page-content region with <Outlet/>.
 * Because it never unmounts on navigation, the sidebar state persists and
 * the NotificationBell inside Header keeps polling without restart.
 */
export default function AppShell() {
  const { sidebarOpen, toggleSidebar, closeSidebar, isMobile } =
    useSidebarState();
  const { title, subtitle } = usePageMeta();

  return (
    <div className="app-shell">
      <div
        className={`sidebar-overlay ${sidebarOpen && isMobile ? "active" : ""}`}
        onClick={closeSidebar}
      />
      <Sidebar isOpen={sidebarOpen} />
      <div
        className={`main-content ${
          sidebarOpen ? "sidebar-open" : "sidebar-collapsed"
        }`}
      >
        <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        <main className="page-content">
          {title && (
            <div className="page-header">
              <div className="page-heading">
                <h1>{title}</h1>
                {subtitle && <p className="subtitle">{subtitle}</p>}
              </div>
            </div>
          )}
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}